import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { Input, Modal } from 'antd';
import RoundedButton from '../../../../components/RoundedButton/RoundedButton';
import { getSearchParamsObj } from '../../helpers/searchParamsFns';
import { filtersData } from '../../constants/filtersData';
import useSaveFilterMutation from '../../mutations/useSaveFilterMutation';
import { savedFiltersKey } from '../../queries/useSavedFilters';
import { filterType } from '../../constants/common';
import styles from './SaveFilterBlock.module.scss';

const SaveFilterBlock = ({ disabled }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [value, setValue] = useState('');

  const location = useLocation();

  const queryClient = useQueryClient();

  const { mutateAsync: saveFilter, isLoading: saveFilterIsLoading } =
    useSaveFilterMutation({
      onSuccess: () => queryClient.invalidateQueries(savedFiltersKey()),
    });

  const handleChange = (e) => setValue(e.target.value);

  const handleCancel = () => {
    setModalVisible(false);
    setValue('');
  };

  const handleClick = () => setModalVisible(true);

  const handleOk = async () => {
    const searchParamsObj = getSearchParamsObj(location.search, filtersData);

    await saveFilter({
      filter: JSON.stringify(searchParamsObj),
      name: value,
      type: filterType,
    });

    setModalVisible(false);
  };

  return (
    <>
      <RoundedButton
        className={styles.saveFilterBtn}
        text="Сохранить фильтр"
        type="primary-orange"
        disabled={disabled}
        onClick={handleClick}
      />
      <Modal
        visible={modalVisible}
        title="Сохранить фильтр"
        okText="Сохранить"
        onCancel={handleCancel}
        onOk={handleOk}
        okButtonProps={{ disabled: !value.trim() }}
        confirmLoading={saveFilterIsLoading}
        destroyOnClose
      >
        <Input
          placeholder="Название фильтра"
          value={value}
          onChange={handleChange}
          disabled={saveFilterIsLoading}
        />
      </Modal>
    </>
  );
};

export default SaveFilterBlock;
